export default __webpack_public_path__ + "static/media/YAS0070.34I106345_-16751_0.379ed026.jpg";